import {React,useState,useRef} from "react";
import ContactPopup from "../ContactPopup";
import "../ImportExport/ServicePages.css";
import { Helmet } from "react-helmet";

const OPCClosure = () => {
  const [openPopup, setOpenPopup] = useState(false);
  
    const contactRef = useRef(null);
  
    const scrollToContact = () => {
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  return (
    <div className="service-page">

          {/* ✅ SEO */}
      <Helmet>
        <title>OPC Closure Service | One Person Company Strike Off</title>
        <meta
          name="description"
          content="Close your OPC easily with expert ROC compliance support. Fast, hassle-free OPC strike off service in India."
        />
        <meta
          name="keywords"
          content="OPC closure, company strike off, STK-2 filing, ROC compliance"
        />
      </Helmet>


      {/* HERO */}
      <section className="service-hero">
        <h1>OPC Closure Service</h1>
        <p>One Person Company Strike Off & Compliance Closure</p>
      <button className="hero-btn" onClick={scrollToContact} >
            Get Started Today
          </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Closing a One Person Company (OPC) is a legal process under the Companies Act, 2013,
          where the company is formally struck off from the records of the Registrar of Companies (ROC).
        </p>
        <p>
          We provide complete assistance for smooth, fast, and compliant closure with proper documentation.
        </p>
      </section>

      {/* METHODS */}
      <section className="service-section">
        <h2>Methods of Closing an OPC</h2>

        <div className="card">
          <h3>1. Strike Off (Fast Track Closure)</h3>
          <ul>
            <li>No business activity</li>
            <li>No outstanding liabilities</li>
            <li>Bank account inactive or closed</li>
            <li>Sole member decides to close</li>
          </ul>
        </div>

        <div className="card">
          <h3>2. Voluntary Winding Up</h3>
          <ul>
            <li>Company has assets or liabilities</li>
            <li>Formal liquidation required</li>
            <li>Structured closure needed</li>
          </ul>
        </div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our OPC Closure Services Include</h2>
        <ul>
          <li>Eligibility assessment for strike off</li>
          <li>Preparation & filing of STK-2</li>
          <li>Drafting resolutions & declarations</li>
          <li>Filing pending ROC forms</li>
          <li>GST & Income Tax de-registration</li>
          <li>Bank account closure guidance</li>
          <li>End-to-end ROC coordination</li>
        </ul>
      </section>

      {/* WHEN TO CLOSE */}
      <section className="service-section">
        <h2>When Should You Close an OPC?</h2>
        <ul>
          <li>Business is no longer active</li>
          <li>Startup idea discontinued</li>
          <li>No income or transactions</li>
          <li>To avoid compliance costs</li>
          <li>Business restructuring</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>Certificate of Incorporation</li>
          <li>PAN of OPC</li>
          <li>MOA & AOA</li>
          <li>Financial statements (if applicable)</li>
          <li>Bank account closure proof</li>
          <li>Declaration by director/member</li>
          <li>ID & address proof</li>
        </ul>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Proper OPC Closure</h2>
        <ul>
          <li>✔ Avoid penalties & compliance burden</li>
          <li>✔ Clean legal closure with ROC</li>
          <li>✔ No future filings required</li>
          <li>✔ Prevent legal notices</li>
          <li>✔ Maintain compliance history</li>
        </ul>
      </section>

      {/* WHY US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Expert ROC compliance handling</li>
          <li>✔ Quick closure process</li>
          <li>✔ Complete documentation support</li>
          <li>✔ Affordable pricing</li>
          <li>✔ End-to-end assistance</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Want to close your OPC legally?</h2>
        <p>Let our experts handle the entire process for you.</p>
        <button>Contact Us</button>
      </section> */}
      <div className="cta" ref={contactRef}>
        <h2>Want to close your OPC legally?</h2>
        <p>Let our experts handle the entire process for you.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default OPCClosure;